import PropTypes from 'prop-types';
import { getConfig } from '../config.js';
import getClientSlug from '../helpers/clientSlug.js';

export default async function apiService(quary, token, setToken, navigate) {
	const webLink = getConfig().REACT_APP_WEB_LINK;
	let result;

	try {
		const slug = getClientSlug();
		const payload = slug ? { ...quary, slug: slug } : quary;

		result = await fetch(webLink, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'sdk-authorization': `${token?.session_key}`,
			},
			body: JSON.stringify(payload),
		});
	} catch (err) {
		window.dispatchEvent(
			new CustomEvent('global-alert', {
				detail: {
					message: 'Network error. Please check your connection and\ntry again.',
					type: 'Error',
				},
			}),
		);
		return { type: 'error', message: 'Network error' };
	}

	if (!result.ok) {
		let message = `Server error (${result.status}). Please try again later.`;
		try {
			const maybeJson = await result.clone().json();
			if (maybeJson && maybeJson.message) message = maybeJson.message;
		} catch (_) {
			try {
				const txt = await result.clone().text();
				if (txt) message = txt;
			} catch (_) {}
		}
		window.dispatchEvent(
			new CustomEvent('global-alert', {
				detail: {
					message,
					type: 'Error',
				},
			}),
		);
		return { type: 'error', message };
	}

	const responce = await result.json();
	if (responce.type === 'error' && responce.message === 'Session expired') {
		setToken({});
		localStorage.removeItem('user-auth');
		navigate('/');
	}
	return responce;
}

apiService.propTypes = {
	quary: PropTypes.isRequired,
	token: PropTypes.string.isRequired,
	setToken: PropTypes.func.isRequired,
	navigator: PropTypes.isRequired,
};
